module.exports = __webpack_public_path__ + "img/04.9b52b6ef.png";